import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Select, TextInput } from '@guildeducationinc/recess';
import { useLocale } from 'pe-core-frontend';
import { useMemo } from 'react';
export const EmployeeReportSettings = (props) => {
    const { t } = useLocale();
    return (_jsx("div", { children: _jsx(TextInput, { label: t('Employee ID'), value: props.settings.spec.employeeId, onChange: event => props.onChange({
                ...props.settings,
                spec: { ...props.settings.spec, employeeId: event.target.value },
            }) }) }));
};
export const EmployeeSpendReportSettings = (props) => {
    const { t } = useLocale();
    const options = useMemo(() => {
        const years = [];
        const currentYear = new Date().getFullYear();
        for (let i = currentYear; i >= 2024; i--) {
            years.push({ value: i.toString(), label: i.toString() });
        }
        return years;
    }, []);
    const handleSelectChange = (value, propName) => {
        props.onChange({
            ...props.settings,
            spec: {
                ...props.settings.spec,
                [propName]: value && !isNaN(Number(value)) ? Number(value) : undefined,
            },
        });
    };
    return (_jsxs("div", { className: 'flex flex-col gap-3', children: [_jsx(Select, { label: t('Cap Year'), options: options, value: props.settings.spec.capYear, onChange: e => handleSelectChange(e.target?.value, 'capYear') }), _jsx(Select, { label: t('Tax Year'), options: options, value: props.settings.spec.taxYear, onChange: e => handleSelectChange(e.target?.value, 'taxYear') })] }));
};
export const ProgramSpendReportSettings = (props) => {
    const { t } = useLocale();
    const options = useMemo(() => {
        const years = [];
        const currentYear = new Date().getFullYear();
        for (let i = currentYear; i >= 2024; i--) {
            years.push({ value: i.toString(), label: i.toString() });
        }
        return years;
    }, []);
    const handleSelectChange = (value, propName) => {
        props.onChange({
            ...props.settings,
            spec: {
                ...props.settings.spec,
                [propName]: value && !isNaN(Number(value)) ? Number(value) : undefined,
            },
        });
    };
    return (_jsxs("div", { className: 'flex flex-col gap-3', children: [_jsx(Select, { label: t('Cap Year'), options: options, value: props.settings.spec.capYear, onChange: e => handleSelectChange(e.target?.value, 'capYear') }), _jsx(Select, { label: t('Tax Year'), options: options, value: props.settings.spec.taxYear, onChange: e => handleSelectChange(e.target?.value, 'taxYear') })] }));
};
